export default "__VITE_ASSET__ec91caca__"